import ApiErrorAlert from 'src/components/_common/ApiErrorAlert/ApiErrorAlert';
import { HiPencil } from 'react-icons/hi';
import { useIntl } from 'react-intl';
import Badge from 'src/components/_common/Badge/Badge';
import useUser from 'src/hooks/user/useUser';

interface SupervisorBadgeProps {
  id: number;
  onEditClick?: () => void;
  isSecondary?: boolean;
  disabled?: boolean;
}

export default function SupervisorBadge({
  id,
  onEditClick,
  isSecondary = false,
  disabled = false,
}: SupervisorBadgeProps) {
  const { formatMessage } = useIntl();
  const supervisorQuery = useUser(id);

  if (supervisorQuery.isLoading) return null;
  if (supervisorQuery.isError) {
    const message = formatMessage({
      id: 'formListPageInviteSupervisorBadgeErrorMessage',
    });
    return <ApiErrorAlert error={supervisorQuery.error} message={message} />;
  }

  const supervisor = supervisorQuery.data;

  return (
    <Badge type="supervisor" onClick={!disabled ? onEditClick : undefined}>
      {supervisor.displayName}{' '}
      {!isSecondary ? formatMessage({ id: 'primaryAdvisorSuffix' }) : ''}
      {onEditClick && <HiPencil className="ml-1 text-base" />}
    </Badge>
  );
}
